import React, { useState, useRef, useEffect } from "react";
import Script from 'react-load-script'
import CountriesList from "../../backend/countries.json"
import { SlideDown } from 'react-slidedown'
import FormRow from "../FormRow";
import Grid from "../Grid";
import { useTranslation } from 'react-i18next';

const GMAPS_API_KEY = process.env.GATSBY_GMAPS_API_KEY;

//@TODO: Get this from backend via API
// as it mirrors the Configuration>Countries list: https://backend.devel.myesens.com/likeaboss/countries/
const ALLOWED_SHIPPING_COUNTRIES = ['GR'];

const filledAddress = formprops => {
  return (formprops.values.street !== "")
         && (formprops.values.city !== "")
         && (formprops.values.countryCode !== "")
         && (formprops.values.postcode !== "")
}

const filterCountries = CountriesList.filter(country => {
  return ALLOWED_SHIPPING_COUNTRIES.includes(country.value)
})

// @TODO: Localize this so that it works in other countries better
// Not every country has the street in the "route" field but
// some use the "administrative_level_1" fields etc
const componentForm = {
  route: 'long_name',
  street_number: 'short_name',
  locality: 'long_name',
  country: 'short_name',
  postal_code: 'short_name'
};

// example: { ...GOOGLE_FIELDNAME: SYLIUS_FIELDNAME }
const addressMap = {
  street_number: "street",
  route: "street",
  locality: "city",
  country: "countryCode",
  postal_code: "postcode",
};

const GMAPS_ERROR_MSG = "google maps javascript api error";


const PlaceAndAddress = (spreadProps) => {
  const [autocomplete, setAutocomplete] = useState();
  const autoCompleteRef = useRef(null);
  const FormikProps = spreadProps.formprops;
  const FieldsType = spreadProps.type;
  const [focused, setFocused] = useState(filledAddress(FormikProps, FieldsType));
  const [googlemapsFailed, setGooglemapsFailed] = useState(false);
  const { t } = useTranslation();

  // OMG that's so ugly, but there is no other way currently
  // to pick up the gmaps api failing programmatically
  // other than listening to the console error messages
  useEffect(() => {
    console.error = message => {
      if (String(message).toLowerCase().includes(GMAPS_ERROR_MSG)) {
        setGooglemapsFailed(true);
      }
    }
  }, [googlemapsFailed]);

  const initializePlacesAutocomplete = () => {
    const pac = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
    );
    pac.setFields(["address_components", "formatted_address"]);
    pac.addListener("place_changed", () => {
      handlePlaceSelect(pac);
    });
    pac.setComponentRestrictions({
      'country': ALLOWED_SHIPPING_COUNTRIES
    });
    setAutocomplete(pac);
  }
    
  function handlePlaceSelect(autocomplete) {
    const place = autocomplete.getPlace();
    let streetNumber = "";
    
    if (place.address_components) {
      place.address_components.forEach(line => {
        const addressType = line.types[0];
        if (componentForm[addressType]) {
          let value = line[componentForm[addressType]];
          // Small exception to see if route has a street number too
          if (addressType === "street_number") {
            streetNumber = value;
          }
          if (addressType === "route" && streetNumber !== "") {
            value = `${value} ${streetNumber}`;
          }
          FormikProps.setFieldValue(
            addressMap[addressType], 
            value
          );
        }
      }); 
    }

    // The dropdown closes, can submit form now
    FormikProps.setFieldValue(
      "placesAutocompleteOpen", 
      false
    );
  }

  // Bias the autocomplete object to the user's geographical location,
  // as supplied by the browser's 'navigator.geolocation' object.
  // async function geolocate() {
  //   if (navigator.geolocation && autocomplete) {
  //     navigator.geolocation.getCurrentPosition(position => {
  //       var geolocation = {
  //         lat: position.coords.latitude,
  //         lng: position.coords.longitude
  //       };
  //       var circle = new window.google.maps.Circle({
  //         center: geolocation, 
  //         radius: position.coords.accuracy
  //       });
  //       autocomplete.setBounds(circle.getBounds());
  //     });
  //   }
  // }

  return (
    <>
      {googlemapsFailed ?
        <div class="form__row"> 
          <label>
            {t('checkout.information.street')}
          </label>
          <input
            name="street"
            id="street"
            type="text"
            data-cy="street"
            autoComplete="address-line1"
            onFocus={() => {
              setFocused(true);
            }}
            placeholder=""
            onChange={e => {
              FormikProps.setFieldValue(
                "street", 
                e.target.value
              );
            }}
          />
        </div>
      :
        <FormRow
          innerRef={autoCompleteRef}
          label={t('checkout.information.street')}
          name="street"
          id="street"
          type="text"
          data-cy="street"
          autoComplete="address-line1"
          placeholder=""
          formprops={FormikProps}
          onFocus={() => {
            // geolocate();
            setFocused(true);
          }}
          onBlur={e => {
            setFocused(e.target.value !== "");
          }}
          onKeyUp={() => {
            // Prevent the form from submitting while we type
            // which might mean that we are opening the dropdown
            FormikProps.setFieldValue(
              "placesAutocompleteOpen", 
              true
            );
          }}
        />
      }
      
      <SlideDown className="slide-down">
        <div style={{ 
          display: focused || googlemapsFailed ? "block" : "none"
        }}>
          <Grid>
            <Grid size="third">
              <FormRow
                label={t('checkout.information.city')}
                name="city"
                id="city"
                type="text"
                data-cy="city"
                autoComplete="address-level2"
                formprops={FormikProps}
              />
            </Grid>
            <Grid size="third">
              <FormRow
                label={t('checkout.information.country')}
                name="countryCode"
                id="countryCode"
                type="select"
                data-cy="countryCode"
                autoComplete="country"
                formprops={FormikProps}
              >
                {filterCountries.map(country => 
                  <option
                    key={country.value} 
                    value={country.value}
                  >
                    {country.label}
                  </option>
                )}
              </FormRow>
            </Grid>
            <Grid size="third">
              <FormRow
                label={t('checkout.information.postalCode')}
                name="postcode"
                id="postcode"
                type="text"
                data-cy="postcode"
                autoComplete="postal-code"
                formprops={FormikProps}
              />
            </Grid>
          </Grid>
        </div>
      </SlideDown>
      {autocomplete === undefined &&
        <Script
          url={`https://maps.googleapis.com/maps/api/js?key=${GMAPS_API_KEY}&libraries=places`}
          onLoad={initializePlacesAutocomplete}
          />
      }
    </>
  )
}

export default PlaceAndAddress;